import { create } from 'zustand';
import { BrokerResetPasswordInterface } from '../interfaces/BrokerResetPasswordInterface';

const initialBrokerResetPasswordInfo: BrokerResetPasswordInterface = {
    password: '',
    newPassword: '',
    confirmNewPassword: '',
};

interface BrokerResetPasswordStore {
    passwordResetInfo: BrokerResetPasswordInterface;
    validationEnabled: boolean;

    set_password: (v: string) => void;
    set_newPassword: (v: string) => void;
    set_confirmNewPassword: (v: string) => void;

    reset: () => void;
}

export const useBrokerResetPasswordStore = create<BrokerResetPasswordStore>((set) => ({
    passwordResetInfo: initialBrokerResetPasswordInfo,
    validationEnabled: true,

    set_password: (v) => set((s) => ({ passwordResetInfo: { ...s.passwordResetInfo, password: v } })),
    set_newPassword: (v) => set((s) => ({ passwordResetInfo: { ...s.passwordResetInfo, newPassword: v } })),
    set_confirmNewPassword: (v) => set((s) => ({ passwordResetInfo: { ...s.passwordResetInfo, confirmNewPassword: v } })),

    reset: () => {
        set({
            passwordResetInfo: initialBrokerResetPasswordInfo,
            validationEnabled: false,
        });

        setTimeout(() => set({ validationEnabled: true }), 0);
    },
}));
